module.exports = __webpack_public_path__ + "static/10-04112bfe4dd3fa59174bb447641c31a9.jpg";